import { render, staticRenderFns } from "./SignatureReport.vue?vue&type=template&id=97ff6b0c&scoped=true&"
import script from "./SignatureReport.vue?vue&type=script&lang=js&"
export * from "./SignatureReport.vue?vue&type=script&lang=js&"
import style0 from "./SignatureReport.vue?vue&type=style&index=0&id=97ff6b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ff6b0c",
  null
  
)

export default component.exports